import { Tooltip } from "antd";
import { Popover } from 'antd-mobile'
import shape from '@assets/shape.svg';
import './index.scss';

type Props = {
    title: string
}
export default function ({ title }: Props) {
    const isMobile: any = localStorage.getItem("isMobile")
    if (isMobile == 1) {
        return <Popover   className="h5TooltipPanel" content={title}
            trigger='click' >
            <img className="tooltipImg" src={shape} />
        </Popover>
    } else {
        return <Tooltip showArrow={false} title={title} trigger={["click", "hover"]} overlayClassName="tooltipPanel" >
            <img className="tooltipImg" src={shape} />
        </Tooltip>
    }

}